
<h3 class="heading first">Date</h3>

<div class="column-holder">
  <toggle-wrapper class="half-column"
    [toggled]="!!program.dateConfirmed" (onToggle)="toggleDateConfirmed()"
    [readOnly]="readOnly"
    [toggleText]="'DATE ' + ( program.dateConfirmed ? '' : 'NOT ') + 'CONFIRMED'">
    <h5>Start Date</h5>
    <div *ngIf="readOnly" class="date">{{formatted_date ? (formatted_date | date:'EEEE d MMMM y') : ''}}</div>
    <date-picker *ngIf="!readOnly" (onDateChange)="saveDate($event)" [pickedDate]="formatted_date"></date-picker>
    <div>&nbsp;</div>
  </toggle-wrapper>
  <div class="half-column secondary-time-zone-dropdown"  *ngIf="!!program.venueId && otherTimezones.length > 1 && !!program.date">
    <h5>Display Time Zone</h5>
    <timezone-picker [selectedTimeZoneId]="program.timeZoneDetails?.timeZoneId || ''" [timezones]="otherTimezones" (select)="updateDisplayTimeZone($event)"></timezone-picker>
  </div>
</div>

<h3 class="heading location-title" style="margin-top: 20px;">Venue details</h3>

<div class="column-holder">
  <toggle-wrapper class="half-column"
    [toggled]="!!program.locationConfirmed" (onToggle)="toggleLocationConfirmed()"
    [readOnly]=""
    [toggleText]="'ROOM ' + ( program.locationConfirmed ? '' : 'NOT ') + 'CONFIRMED'">
    <h5>Venue room/location</h5>
    <joi-input [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="program.location" 
      placeholder="Add venue room/location..." (joiChange)="saveProgram()"></joi-input>
  </toggle-wrapper>
  <toggle-wrapper class="half-column venue-holder"
    [toggled]="!!program.venueConfirmed" (onToggle)="toggleVenueConfirmed()"
    [readOnly]="readOnly"
    [toggleText]="'VENUE ' + ( program.venueConfirmed ? '' : 'NOT ') + 'CONFIRMED'">
      <!--<icon class="map-icon" [matIcon]="'my_location'" *ngIf="!!program?.venueDetails?.place_id" (click)="openVenueMap()" ></icon> -->
    <h5>Venue name & address</h5>
    <div *ngIf="event.venues[program.venueId] && !event.venues[program.venueId].googleId" class="outdatedvenueformatwarning"><div class="head">Outdated venue format!</div>Please create a new venue by clicking <i>SELECT VENUE</i>.</div>
    <add-manage-wrapper 
      *ngIf="{ venue: event.venues[program.venueId] } as vars"
      class="narrow"
      style="margin-top: 10px;"
      [hideHRule]="true"
      [readOnly]="readOnly"
      [openLabel]="readOnly ? '' : 'SELECT VENUE'" 
      (open)="manageVenue($event)" 
      >
      <div class="empty-text" *ngIf="!vars.venue" >No venue selected...</div>
      <div class="info-content" *ngIf="!!vars.venue" >
        <div (click)="helpers.openInNewTab('https://www.google.com/maps/place/?q=place_id:' + vars.venue.googleId)"  class="secondary_link">{{ vars.venue.venue }}</div>
        <div class="note">{{ vars.venue.address }}</div>
      </div>
    </add-manage-wrapper>
    <h5 class="time-zone" style="margin-top:15px;">Time Zone</h5>
    <div class="time-zone" *ngIf="!program.secondaryTimeZoneDetails">
      {{ program.timeZoneDetails?.abbr }} (GMT {{ program.timeZoneDetails?.offsetText }})
    </div>
    <div class="time-zone" *ngIf="program.secondaryTimeZoneDetails">
      {{ program.secondaryTimeZoneDetails?.abbr }} (GMT {{ program.secondaryTimeZoneDetails?.offsetText }})
    </div>
  </toggle-wrapper>
</div>
